module.exports = __webpack_public_path__ + "img/icon7.1703f710.png";